import React from 'react';
import './booking-shared.css';
import './checkout.css';

const gbp = (pence) => `£${(pence / 100).toFixed(2)}`;

// The figures the server worked out for a checkout, shown on the payment
// screen: each line, the credit applied, and the amount the card is charged
// (the PaymentIntent's own amount). Nothing here is worked out in the browser.
export default function CheckoutSummary({ summary }) {
  if (!summary || typeof summary.amount !== 'number') return null;
  const { lines = [], creditApplied = 0, amount } = summary;
  const above = lines.length || creditApplied;
  return (
    <div className="bk-card checkout-totals" data-testid="checkout-summary">
      {lines.map((l, i) => (
        <div key={i} className="checkout-totals__row">
          <span>{l.description}{l.quantity > 1 ? ` × ${l.quantity}` : ''}</span>
          <span>{gbp(l.amount)}</span>
        </div>
      ))}
      {creditApplied > 0 && (
        <div className="checkout-totals__row">
          <span>Credit applied</span><span>−{gbp(creditApplied)}</span>
        </div>
      )}
      <div className={`checkout-totals__pay${above ? ' checkout-totals__pay--after' : ''}`}>
        <span>To pay now</span><span>{gbp(amount)}</span>
      </div>
    </div>
  );
}

// The summary fields of a checkout response, or null if it has none
export function summaryFrom(data) {
  if (!data || typeof data.amount !== 'number') return null;
  return { amount: data.amount, creditApplied: data.creditApplied || 0, total: data.total, lines: data.lines || [] };
}
